import { useState } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SimpleOpenLayersMap from "./cachementMap";
import VehicleList from "./VehicleList";
import MDTypography from "components/MDTypography";
import DhundhooLoader from "../Loader/Loader";

function CachementDashboard() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [journeys, setJourneys] = useState([]);
  const [selectedJourneys, setSelectedJourneys] = useState({});

  // Same global colors
  const journeyColors = [
    '#FF0000', '#00FF00', '#0000FF', '#FFA500', '#800080', '#008000'
  ];

  // Helper function to assign fixed colors based on original index
  const getJourneyColor = (journeyId) => {
    const index = journeys.findIndex((j) => j.journeyId === journeyId);
    return journeyColors[Math.max(0, index) % journeyColors.length];
  };

  const handleJourneysChange = (newJourneys, newSelectedJourneys) => {
    setJourneys(newJourneys);
    setSelectedJourneys(newSelectedJourneys);
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="80vh"
        >
          <DhundhooLoader />
          <MDBox mt={3} width="50%">
            <LinearProgress variant="determinate" value={progress} />
          </MDBox>
          <Typography variant="h6" mt={2}>
            {progress}% loaded...
          </Typography>
        </MDBox>
      </DashboardLayout>
    );
  }

  // Filter selected journeys
  const selectedJourneysList = journeys.filter(
    (journey) => selectedJourneys[journey.journeyId] === true
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={3}>
          {/* Left side - Vehicles */}
          <Grid item xs={12} md={4} lg={5}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <VehicleList onJourneysChange={handleJourneysChange} />
              </Grid>
            </Grid>
          </Grid>

          {/* Right side - Map and Journey Details */}
          <Grid item xs={12} md={8} lg={7}>
            <Grid container direction="column" spacing={3}>
              <Grid item xs={12}>
                <SimpleOpenLayersMap journeys={journeys} selectedJourneys={selectedJourneys} />
              </Grid>
              
              {selectedJourneysList.length > 0 && (
                <Grid item xs={12}>
                  <MDBox
                    sx={{
                      maxHeight: '200px',
                      overflowY: 'auto',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: '10px',
                      backgroundColor: '#f9f9f9',
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ccc",
                        borderRadius: "4px",
                      },
                    }}
                  >
                    {selectedJourneysList.map((journey) => {
                      // Fetch absolute assigned color
                      const routeColor = getJourneyColor(journey.journeyId);
                      
                      return (
                        <MDBox key={journey.journeyId} mb={3} sx={{ "&:last-child": { mb: 0 } }}>
                          <MDTypography variant="h6" fontWeight="medium" sx={{ color: routeColor }}>
                            {journey.journeyName} {journey.type} ({journey.interval.startTime}-{journey.interval.endTime})
                          </MDTypography>
                          <MDTypography variant="button" fontWeight="medium" display="block" mt={0.5}>
                            Stops:
                          </MDTypography>
                          <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                            {journey.stopPoints.map((stop, stopIndex) => (
                              <li key={stopIndex} style={{ marginBottom: "2px" }}>
                                <MDTypography variant="body2">
                                  {stopIndex + 1}: {stop.locationName}
                                </MDTypography>
                              </li>
                            ))}
                          </ul>
                        </MDBox>
                      );
                    })}
                  </MDBox>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CachementDashboard;